import { Redirect, useLocation } from 'react-router-dom';
import useAuth from '../hooks/use-auth';
import PageWrapper from '../components/PageWrapper';
import { toast } from 'react-toastify';
import ConfirmEmail from '../components/Auth/ConfirmEmail';
import { ROUTES } from '../routing';

export default function ConfirmEmailPage() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const email = (location.state as { email: string })?.email ?? '';
  const returnTo =
    (location.state as { returnTo: string })?.returnTo ?? undefined;

  if (isAuthenticated) {
    toast.error('You are logged in already');
    return <Redirect to={ROUTES.HOME.getPath()} />;
  }

  if (!email) {
    toast.error('Sorry, something went wrong');
    return <Redirect to={ROUTES.AUTH.LOGIN.getPath()} />;
  }

  return (
    <PageWrapper style={{ height: '100vh' }}>
      <ConfirmEmail
        email={email}
        redirectUri={`${
          window.location.origin
        }${ROUTES.AUTH.CALLBACK.getPath()}`}
        returnTo={returnTo}
      />
    </PageWrapper>
  );
}
